import React from "react";
import { Minus, Plus } from "lucide-react";

const QUICK = {
  vocal_technique: [10, 20, 30, 35, 40],
  interpretation: [10, 15, 20, 25, 30],
  stage_presence: [5, 10, 15, 18, 20],
  overall_performance: [2, 4, 6, 8, 10],
};

export default function CriterionCard({ criterion, value, onChange, disabled }) {
  const { id, name, max } = criterion;
  const v = value ?? 0;

  const clamp = (n) => Math.max(0, Math.min(max, n));
  const set = (n) => !disabled && onChange(clamp(n));

  const pct = (v / max) * 100;

  return (
    <div className="card-kwc p-4" data-testid={`criterion-card-${id}`}>
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="font-display font-bold text-slate-100">{name}</div>
          <div className="text-[11px] text-slate-500">Max {max}</div>
        </div>
        <div className="font-score font-extrabold text-2xl text-amber-400" data-testid={`criterion-${id}-value`}>
          {value === null || value === undefined ? "—" : v}
        </div>
      </div>

      <div className="flex items-center gap-3">
        <button
          type="button"
          data-testid={`criterion-${id}-decrease`}
          onClick={() => set(v - 1)}
          disabled={disabled}
          className="w-12 h-12 rounded-xl text-2xl font-black bg-slate-800 border border-amber-500/30 text-amber-200 active:bg-amber-500 active:text-slate-950 disabled:opacity-40 flex items-center justify-center transition-colors"
        >
          <Minus className="w-5 h-5" />
        </button>

        <input
          type="range"
          className="kwc-range flex-1"
          min={0}
          max={max}
          step={1}
          value={v}
          disabled={disabled}
          data-testid={`criterion-${id}-input`}
          onChange={(e) => set(parseInt(e.target.value, 10))}
        />

        <button
          type="button"
          data-testid={`criterion-${id}-increase`}
          onClick={() => set(v + 1)}
          disabled={disabled}
          className="w-12 h-12 rounded-xl text-2xl font-black bg-slate-800 border border-amber-500/30 text-amber-200 active:bg-amber-500 active:text-slate-950 disabled:opacity-40 flex items-center justify-center transition-colors"
        >
          <Plus className="w-5 h-5" />
        </button>
      </div>

      <div className="w-full h-1.5 rounded-full bg-slate-800 mt-3 overflow-hidden">
        <div className="h-full bg-gradient-to-r from-amber-500 to-yellow-400 transition-all" style={{ width: `${pct}%` }} />
      </div>

      <div className="flex flex-wrap gap-2 mt-3">
        {QUICK[id]?.map((q) => (
          <button
            key={q}
            type="button"
            data-testid={`criterion-${id}-quick-${q}`}
            onClick={() => set(q)}
            disabled={disabled}
            className={`px-3 h-9 rounded-lg text-sm font-semibold border transition-colors disabled:opacity-40 ${
              v === q
                ? "bg-amber-500 text-slate-950 border-amber-500"
                : "bg-slate-900 text-slate-300 border-slate-700 hover:border-amber-500/40"
            }`}
          >
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}
